import { AxiosResponse } from "axios";

// Models
import { Result } from "@/main/models/common/resultResponse";
import { QuoteHistoricalMainResponse, QuoteHistoricalResponse } from "@/main/models/response/quoteHistoricalResponse";
import { QuoteHistoryRequest } from "@/main/models/request";
import { PaginationRequest } from "@/main/models/common/paginationRequest";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

export abstract class IQuoteHistoricalApi {
	abstract getQuoteHistory(
		request: PaginationRequest,
		guidQuote: string,
	): Promise<AxiosResponse<PaginationResponse<QuoteHistoricalMainResponse>>>;
	abstract getQuoteHistoryDetail(request: QuoteHistoryRequest): Promise<AxiosResponse<Result<QuoteHistoricalResponse>>>;
}
